export default __webpack_public_path__ + "static/media/flipkart-white.892da409.svg";